export default {
  Team: {
    TITLE: 'Team',
    INVITE: 'Invite a Teammate',
    MEMBERS: 'Members',
    PENDING: 'Pending',
    Table: {
      NAME: 'Name',
      EMAIL: 'Email',
      PERMISSIONS: 'Permissions',
      STATUS: 'Status',
      COMPLETE: 'Complete',
      WAITING: 'Invited',
      Permission: {
        owner: 'Owner',
        readwrite: 'User',
        read: 'Read only',
      },
    },
    Invite: {
      TITLE: 'Invite a Teammate',
      DESCRIPTION: 'Use their Xero login email to invite them to collaborate with you on Mayday',
      INVITE: 'Send Invite',
      RESEND: 'Resend Invite',
      FORM_ERROR: 'There was an error. Please check the form and try again.',
      ADD_ANOTHER: '+ Invite another user',
      RESEND_BODY: 'Resend invite email to {{email}} to invite them to collaborate with you on Mayday?',
    },
    Remove: {
      TITLE: 'Remove User',
      DESCRIPTION: 'Are you sure you would like to remove {{email}} from your group? This action cannot be undone.',
      REMOVE: 'Remove',
    },
  },
};
